import React from 'react';
export function HeroSection() {
  return <section className="relative pt-10 pb-12 md:pt-24 md:pb-28 overflow-hidden px-4 sm:px-6 lg:px-8" data-id="element-121">
      {/* Background glow — hidden on mobile for GPU perf */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[600px] bg-blue-600/15 blur-[150px] rounded-full pointer-events-none hidden md:block" data-id="element-122" />

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-123">
        {/* Brand Tag */}
        <div className="hero-animate-1 inline-flex items-center gap-2 px-3 py-1 md:px-4 md:py-1.5 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-400 font-semibold text-xs md:text-sm tracking-wider mb-4 md:mb-8" data-id="element-124">
          💑 MATRIMONIO SIN CRISIS
        </div>

        {/* Main Headline */}
        <h1 className="hero-animate-2 text-3xl sm:text-5xl md:text-7xl lg:text-8xl font-extrabold leading-[1.08] tracking-tight mb-2 md:mb-4 text-white" data-id="element-125">
          Todo lo que necesitás para rescatar tu relación.
        </h1>

        {/* Accent Subheadline */}
        <p className="hero-animate-2 text-2xl sm:text-4xl md:text-6xl lg:text-7xl font-extrabold text-blue-400 mb-6 md:mb-12" data-id="element-126">
          Listo. Desde hoy.
        </p>

        {/* Product Image */}
        <div className="relative max-w-sm md:max-w-2xl mx-auto mb-6 md:mb-12" data-id="element-127">
          <div className="absolute inset-0 bg-gradient-to-tr from-blue-600/15 to-blue-400/5 blur-2xl rounded-full scale-110 hidden md:block" data-id="element-128" />
          <picture data-id="element-129">
            <source srcSet="https://cdn.magicpatterns.com/uploads/4kHBUicmaLGsRUTQWJVZdM/MOCAP_PNG_SIN_FONDO_MATRIMONIO.webp" type="image/webp" data-id="element-130" />
            <img src="https://cdn.magicpatterns.com/uploads/4kHBUicmaLGsRUTQWJVZdM/MOCAP_PNG_SIN_FONDO_MATRIMONIO.webp" alt="Megapack Matrimonio Sin Crisis — Colección Completa" className="relative z-10 w-full h-auto" width={672} height={672} loading="eager" decoding="async" fetchPriority="high" data-id="element-131" />
          </picture>
        </div>

        {/* Product Description */}
        <div className="hero-animate-3 max-w-3xl mx-auto mb-6 md:mb-10" data-id="element-132">
          <h2 className="text-base md:text-2xl font-bold text-blue-300 mb-2 md:mb-3" data-id="element-133">
            El sistema N°1 de rescate y blindaje para parejas en Latinoamérica —
            Para cualquier etapa de la relación
          </h2>
          <p className="text-sm md:text-lg text-slate-400 leading-relaxed" data-id="element-134">
            Protocolos + ejercicios + acuerdos listos para usar. Sin buscar. Sin
            improvisar. Sin perder más días sin saber cómo salvar lo que más
            amás.
          </p>
        </div>

        {/* Trust Badges */}
        <div className="hero-animate-4 flex flex-wrap items-center justify-center gap-2 md:gap-3 mb-6 md:mb-10" data-id="element-135">
          {[{
          emoji: '📄',
          label: '100% PDF'
        }, {
          emoji: '⚡',
          label: 'Acceso en 5 min'
        }, {
          emoji: '🌎',
          label: 'Edición completa'
        }, {
          emoji: '📚',
          label: '6 Tomos + 6 Bonos'
        }].map((badge, i) => <span key={i} className="inline-flex items-center gap-1.5 md:gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-navy-700/60 border border-navy-600 text-xs md:text-sm font-medium text-slate-300" data-id="element-136">
              <span data-id="element-137">{badge.emoji}</span> {badge.label}
            </span>)}
        </div>

        {/* CTA Button */}
        <div className="hero-animate-5 flex flex-col items-center" data-id="element-138">
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-blue-600 hover:bg-blue-500 text-white font-semibold text-sm md:text-lg py-3 px-6 md:py-3.5 md:px-10 rounded-full shadow-[0_0_25px_rgba(59,130,246,0.3)] transition-all transform hover:scale-[1.03] flex items-center justify-center gap-2" data-id="element-139">
            💑 → QUIERO MI MEGAPACK AHORA
          </button>

          {/* Payment Info */}
          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-5 mt-4 md:mt-5 text-[10px] md:text-sm text-slate-500" data-id="element-140">
            <span data-id="element-141">🛡️ Garantía 7 días</span>
            <span className="text-slate-700" data-id="element-142">•</span>
            <span data-id="element-143">🔒 Pago seguro</span>
            <span className="text-slate-700" data-id="element-144">•</span>
            <span data-id="element-145">💳 Mercado Pago | Tarjeta</span>
          </div>
        </div>
      </div>
    </section>;
}